<p-toast />
<app-container-manager-login title="Criar Conta">
  <form [formGroup]="form" class="p-fluid" autocomplete="off" (submit)="onSubmit()">
    <div class="p-field p-mb-3">
      <label for="cnpj" class="p-mb-2 block">CNPJ</label>
      <p-inputMask inputId="cnpj" formControlName="cnpj" placeholder="CNPJ" mask="99.999.999/9999-99"
        [unmask]="true"></p-inputMask>
      <app-form-errors [control]="form.get('cnpj')"></app-form-errors>
    </div>

    <div class="p-field p-mb-3">
      <label for="nome" class="p-mb-2 block">Nome</label>
      <input id="nome" type="text" pInputText placeholder="Nome completo" formControlName="nome" />
      <app-form-errors [control]="form.get('nome')"></app-form-errors>
    </div>

    <div class="p-field p-mb-3">
      <label for="fone" class="p-mb-2 block">Telefone</label>
      <p-inputMask inputId="fone" mask="(99) 9 9999-9999" [unmask]="true" placeholder="Telefone"
        formControlName="fone"></p-inputMask>
      <app-form-errors [control]="form.get('fone')"></app-form-errors>
    </div>

    <div class="p-field p-mb-3">
      <label for="email" class="p-mb-2 block">E-mail</label>
      <input id="email" type="email" pInputText placeholder="E-mail" formControlName="email" />
      <app-form-errors [control]="form.get('email')"></app-form-errors>
    </div>

    <div class="p-field p-mb-3">
      <label for="senha" class="p-mb-2 block">Senha</label>
      <p-password id="senha" formControlName="senha" placeholder="Senha" [toggleMask]="true" [feedback]="true"
        styleClass="w-full" inputStyleClass="w-full" [weakLabel]="'Fraca'" [mediumLabel]="'Média'"
        [strongLabel]="'Forte'" promptLabel="Digite a senha">
        <ng-template pTemplate="footer">
          <div class="password-requirements" *ngIf="senhaControl?.touched || senhaControl?.dirty">
            <small class="p-d-block" [class.text-success]="hasUpperCase" [class.text-error]="!hasUpperCase">
              <i class="pi" [class.pi-check]="hasUpperCase" [class.pi-times]="!hasUpperCase"></i>
              Letra maiúscula (A-Z)
            </small>
            <small class="p-d-block" [class.text-success]="hasLowerCase" [class.text-error]="!hasLowerCase">
              <i class="pi" [class.pi-check]="hasLowerCase" [class.pi-times]="!hasLowerCase"></i>
              Letra minúscula (a-z)
            </small>
            <small class="p-d-block" [class.text-success]="hasNumeric" [class.text-error]="!hasNumeric">
              <i class="pi" [class.pi-check]="hasNumeric" [class.pi-times]="!hasNumeric"></i>
              Número (0-9)
            </small>
            <small class="p-d-block" [class.text-success]="hasSpecialChar" [class.text-error]="!hasSpecialChar">
              <i class="pi" [class.pi-check]="hasSpecialChar" [class.pi-times]="!hasSpecialChar"></i>
              Caractere especial (!&#64;#$%...)
            </small>
            <small class="p-d-block" [class.text-success]="isValidLength" [class.text-error]="!isValidLength">
              <i class="pi" [class.pi-check]="isValidLength" [class.pi-times]="!isValidLength"></i>
              Mínimo 8 caracteres
            </small>
          </div>
        </ng-template>
      </p-password>
    </div>

    <div class="p-field p-mb-3">
      <button pButton type="submit" [disabled]="form.invalid || loadding" [label]="loadding ? '' : 'Cadastrar'"
        class="p-button-primary w-full p-d-flex p-jc-center p-ai-center">
        <i class="pi pi-spin pi-spinner" *ngIf="loadding"></i>
      </button>
      <div *ngIf="loadding && progressMessage" class="p-text-center p-mt-2">
        <small class="text-muted">{{ progressMessage }}</small>
      </div>
    </div>

    <div class="p-text-left">
      <span>Já tem uma conta? </span>
      <a [routerLink]="['/login']" class="p-link auth-link">
        Acessar
      </a>
    </div>
  </form>
</app-container-manager-login>